import React from "react";
import { useTranslation } from "react-i18next";
import WaitlistTokenLanding from "../components/common/WaitlistTokenLanding";

export default function WaitlistStatusPage() {
  const { t } = useTranslation();

  return (
    <WaitlistTokenLanding
      pageTitle="Waitlist Status Login"
      type="status"
      loadingTitle={t("Logging you in to waitlist status...")}
      loadingDesc={t("Please wait while we confirm your access link.")}
      successTitle={t("Access Granted!")}
      successDesc={t("Redirecting you to the film page...")}
      successToast={t("Authenticated successfully!")}
      defaultErrorMsg={t("Invalid or expired status link.")}
      errorTitle={t("Authentication Failed")}
      autoRedirect={true}
    />
  );
}
